import { cn } from "@/lib/utils";
import { ComponentProps, forwardRef } from "react";

export const RequestFeatureCard = forwardRef<HTMLDivElement, ComponentProps<"div">>(
  ({ className, ...props }, ref) => (
    <div
      className={cn("flex max-w-160 items-center gap-5.25 py-3.5 ps-10 pe-8.25 pt-2.5", className)}
      {...props}
      ref={ref}
    />
  ),
);

export const FeatureListRoot = forwardRef<HTMLDivElement, ComponentProps<"div">>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "bg-paper relative mt-0 flex min-h-0 max-w-255.5 flex-1 flex-col overflow-y-auto rounded p-0",
        className,
      )}
      {...props}
    />
  ),
);

export const FeatureListList = forwardRef<HTMLDivElement, ComponentProps<"div">>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("mb-6.25 flex min-h-0 flex-1 flex-col overflow-y-auto", className)}
      {...props}
    />
  ),
);

export const FeatureListTitle = forwardRef<HTMLDivElement, ComponentProps<"h3">>(
  ({ className, ...props }, ref) => (
    <h3
      ref={ref}
      className={cn("border-divider -mb-[1.6px] sticky top-0 z-1 border-b-2 px-[36.5px] py-5", className)}
      {...props}
    />
  ),
);
